import api, { handleApiResponse } from './api';
import { UserManagement, CreateUserRequest, UpdateUserRequest, ApiResponse, UserProfileResponse, UpdateUserProfileRequest } from '../types';

export const userService = {
  async getAll(): Promise<UserManagement[]> {
    // El backend devuelve Page<UserResponse> — extraemos el array .content.
    // Se solicita página 0 con tamaño grande para obtener todos los usuarios del tenant.
    const response = await api.get<ApiResponse<{ content: UserManagement[] }>>
      ('/auth/users?size=200&sort=id,asc');
    const data = handleApiResponse(response);
    return Array.isArray(data) ? data : (data?.content ?? []);
  },

  async create(data: CreateUserRequest): Promise<UserManagement> {
    const response = await api.post<ApiResponse<UserManagement>>('/auth/users', data);
    return handleApiResponse(response);
  },

  async update(id: number, data: UpdateUserRequest): Promise<UserManagement> {
    const response = await api.put<ApiResponse<UserManagement>>(`/auth/users/${id}`, data);
    return handleApiResponse(response);
  },

  async deactivate(id: number): Promise<void> {
    await api.delete(`/auth/users/${id}`);
  },

  async getUserProfile(id: number): Promise<UserProfileResponse> {
    const response = await api.get<ApiResponse<UserProfileResponse>>(`/auth/users/${id}/profile`);
    return handleApiResponse(response);
  },

  async updateUserProfile(id: number, data: UpdateUserProfileRequest): Promise<UserProfileResponse> {
    const response = await api.patch<ApiResponse<UserProfileResponse>>(`/auth/users/${id}/profile`, data);
    return handleApiResponse(response);
  },
};
